
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData, SyncData } from '../../../apiService';
import { Card, CardContent, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';


const PROSaleOrderCreate = () => {
    const { id, tid } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [expandedCategories, setExpandedCategories] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [categoryData, setCategoryData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]);
    const handleExpandClick = (categoryName) => {
        setExpandedCategories((prevExpanded) => {
            if (prevExpanded.includes(categoryName)) {
                return prevExpanded.filter((cat) => cat !== categoryName);
            } else {
                return [...prevExpanded, categoryName];
            }
        });
    };
    const [data, setData] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');

    useEffect(() => {
        const fetchTripDataFromApi = async () => {
            try {
                const response = await fetchData('RouteApi', `/${id}/${tid}`, token);
                if (response.responseCode === '1111') {
                    // Assuming response_data is an array, you can access it directly
                    const dataArray = response.response_data;
                    console.error(dataArray);
                    // Now you can iterate over the array or access elements as needed
                    dataArray.forEach(item => {

                    });
                    setData(dataArray);
                    if (dataArray.length > 0) {
                        setCustomerName(dataArray[0].name);
                        setTripdate(dataArray[0].tripDate)
                        setCustomerId(dataArray[0].id)
                    }
                }
            } catch (error) {
                console.error('Error fetching customer Data:', error);
            }
        };

        if (tid && id) {
            fetchTripDataFromApi();
        }
    }, [tid, id, token]);

    useEffect(() => {
        const fetchDataFromApi = async () => {
            try {
                const response = await fetchData('CustomerSaleCategoryApi', `/${companyId}/${id}`, token);
                if (response.responseCode === '1111') {
                    setCategoryData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Category Data:', error);
            }
        };

        if (companyId && id) {
            fetchDataFromApi();
        }
    }, [companyId, id, token]);



    const handleIncrement = (CategoryId, ItemId, itemName, quantity, rate) => {
        setSelectedItems((prevItems) => {
            const existingItemIndex = prevItems.findIndex((item) => item.ItemId === ItemId);
            const parsedQuantity = quantity === '' ? 0 : parseInt(quantity);
            const parsedRate = parseFloat(rate);


            // Calculate amounts
            const discount = 0;
            const amount = (parsedQuantity * parsedRate).toFixed(2);
            const netAmount = (amount - discount).toFixed(2);
            const totalAmount = (parseFloat(netAmount)).toFixed(2);

            // Avoid mutating the state directly
            let updatedItems;
            if (parsedQuantity <= 0) {
                if (existingItemIndex !== -1) {
                    // Remove item if quantity is 0 or negative
                    updatedItems = prevItems.filter(item => item.ItemId !== ItemId);
                } else {
                    updatedItems = prevItems;
                }
            } else {
                if (existingItemIndex !== -1) {
                    // Update existing item's quantity
                    updatedItems = prevItems.map(item =>
                        item.ItemId === ItemId ? { ...item, Quantity: parsedQuantity } : item
                    );
                } else {
                    // Add new item
                    updatedItems = [...prevItems, {
                        CategoryId,
                        ItemId,
                        Quantity: parsedQuantity,
                        itemName,
                        gstRate: 0,
                        Amount: totalAmount,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        NetAmount: netAmount,
                        TotalAmount: totalAmount,
                        Rate: parsedRate
                    }];
                }
            }

            const newTotalQuantity = updatedItems.reduce(
                (total, item) => total + (isNaN(item.Quantity) ? 0 : Math.max(item.Quantity, 0)),
                0
            );
            setTotalQuantity(newTotalQuantity);

            return updatedItems;
        });
    };

    //Round off
    const roundToNearest = (value) => {
        const roundedValue = Math.round(value);
        return { roundedValue, roundOff: roundedValue - value };
    };

    // Calculate totals
    const TotalnetAmount = selectedItems.reduce((acc, item) => acc + parseFloat(item.NetAmount), 0).toFixed(2);
    const TotaltotalAmount = selectedItems.reduce((acc, item) => acc + parseFloat(item.TotalAmount), 0);
    const { roundedValue, roundOff } = roundToNearest(TotaltotalAmount);
    const TotaltotalAmountRounded = roundedValue.toFixed(2);
    // Save the round-off value
    const roundOffValue = roundOff.toFixed(2);

    const TotalSaleAmount = selectedItems.reduce((acc, item) => acc + parseFloat(item.Amount), 0).toFixed(2);

    const getTotalQuantityForCategory = (categoryId) => {
        return selectedItems.reduce((total, item) => {
            if (item.CategoryId === categoryId) {
                const itemQuantity = isNaN(item.Quantity) ? 0 : item.Quantity;
                return total + itemQuantity;
            }
            return total;
        }, 0);
    };

    const submitData = async (e) => {
        e.preventDefault();

        // Filter out items with zero quantity
        const itemsToSave = selectedItems.filter(item => item.Quantity > 0);

        // Check if any items are selected after filtering
        if (itemsToSave.length === 0) {
            alert('Please select at least one item to proceed with the order.');
            return;
        }

        const saleorderdata = {
            TripId: tid,
            CustomerId: customerId,
            OrderDate: tripdate,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
            Amount: TotalSaleAmount,
            NetAmount: TotalnetAmount,
            TotalAmount: TotaltotalAmountRounded, // TotaltotalAmount,
            CGSTAmount: 0,
            SGSTAmount: 0,
            IGSTAmount: 0,
            Roundoff: roundOffValue,
            PaidAmount: 0,
            BalanceAmount: 0,
            Discount: 0,
        };

        const CreateData = {
            SaleOrder: saleorderdata,
            SaleOrderDetails: itemsToSave,
        };

        // Show a confirmation dialog before submitting the order
        const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
        if (confirmOrder) {
            postData('PROSaleOrderApi', CreateData, token)
                .then((response) => {
                    if (response.response === '1111') {
                        const SaleOrderid = response.SaleOrderId;
                        history.push(`/NongstTriporderedIndexs/${tid}`);
                    }
                })
                .catch((error) => {
                    console.error('SaleOrder Create error:', error);
                });
        }
    };


    return (
        <div className="container mx-auto mt-2 p-4 max-w-screen-md" style={{ maxHeight: '820px', overflowY: 'auto' }}>
            <form onSubmit={submitData}>
               
                {selectedItems.some(item => item.Quantity > 0) ? (
                    <div className="flex mb-2">
                        <div className="banner-style flex items-center justify-between text-white px-4 py-2 rounded-lg w-full" style={{ backgroundColor: 'rgba(38, 166, 154, 0.3)' }}>
                            {/* <LocalShippingIcon style={{ color: 'black' }} /> */}
                            <h4 className="flex-grow text-black font-serif" style={{ marginLeft: '20px' }}>{totalQuantity} Items</h4>
                            <Button variant="contained" color="primary" type="submit" style={{ width: "150px", fontSize: '12px' }}>Order Confirm</Button>
                        </div>
                    </div>
                ) : null}

                <div className="flex mb-2">
                    <h4 className="flex-grow text-black font-serif" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                        {customerName}
                    </h4>

                    <h5 className="flex-grow text-black font-serif" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                        OrderDate : {tripdate && new Date(tripdate).toLocaleDateString('en-GB')}
                    </h5>
                </div>

                {categoryData.map((category) => (
                    <Card key={category.CategoryName} sx={{ marginBottom: 1, boxShadow: '0 1px 2px rgba(0,0,0,0.1)', backgroundColor: 'rgba(255,255,255,0.8)' }}>
                        <CardContent>
                            <Typography
                                variant="h6"
                                component="div"
                                sx={{
                                    marginBottom: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '10px',
                                    fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => handleExpandClick(category.CategoryName)}
                            >
                                {category.CategoryName}
                                {getTotalQuantityForCategory(category.CategoryId) > 0 && (
                                    <span style={{ marginLeft: 'auto', marginRight: '10px' }}>
                                        ({getTotalQuantityForCategory(category.CategoryId)} items)
                                    </span>
                                )}
                                <IconButton
                                    aria-expanded={expandedCategories.includes(category.CategoryName)}
                                    aria-label="show more"
                                    sx={{ marginLeft: 'auto' }}
                                >
                                    <ExpandMoreIcon />
                                </IconButton>
                            </Typography>

                            <Collapse in={expandedCategories.includes(category.CategoryName)} timeout="auto" unmountOnExit>
                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            {category.Items.map((item) => (
                                                <TableRow key={item.Id}>
                                                    <TableCell sx={{ fontSize: '16px', width: '220px' }}>{item.Name} ({item.Weight})</TableCell>
                                                    <TableCell sx={{ width: '30px', padding: '1px', fontSize: '16px', fontWeight: 'bold' }}>

                                                        <input
                                                            type="number"
                                                            min="0"
                                                            value={selectedItems.find((selectedItem) => selectedItem.ItemId === item.Id)?.Quantity}
                                                            onChange={(e) => handleIncrement(category.CategoryId, item.Id, item.Name, parseInt(e.target.value), item.Rate)}
                                                        />

                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Collapse>
                        </CardContent>
                    </Card>
                ))}
            </form>
        </div>
    );
};

export default PROSaleOrderCreate;
